import { FormDataDto } from "@api/form-data-dto";
import { CompanyFieldCategoryDto } from "@api/company-field-category-dto";
import { InjectionKey, Ref } from "vue";

export default Symbol("Company form info (PublicForm && FieldCategories)") as InjectionKey<
	Ref<FormDataDto<CompanyFieldCategoryDto> | null>
>;
